/*
  Copyright (C) 2022 Sber

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

  http://www.apache.org/licenses/LICENSE-2.0

  In any derivative products, you must retain the information of
  owner of the original code and provide clear attribution to the project

  https://dochub.info

  The use of this product or its derivatives for any purpose cannot be a secret.


  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.

  Maintainers:
      Sergeev Viktor, Sber - 2025

  Contributors:
      Sergeev Viktor <sergeevviktor017@gmail.com>, Sber - 2025
*/

import env from '@front/helpers/env';
import {appendCoreFunctions} from '@global/jsonata/driver';

/**
 * Получение версий системы в режиме плагина или frontend
 */
function getVersion() {
    const pluginVersion = env.pluginVersion;
    const pluginName = env.pluginName;
    const appVersion = __APP_VERSION__;
    const mode = env.isPlugin() ? 'plugin' : env.isBackendMode ? 'portal' : 'fat_client';
    const pluginMode = env.pluginMode;
    return {
        coreVersion: appVersion,
        pluginVersion: pluginVersion,
        pluginName: pluginName,
        settings: {
            mode: mode,
            pluginMode: pluginMode
        }
    };
}

/**
 * Регистрация функции в движке jsonata
 */
export function registerJsonataVersionFunction() {
    appendCoreFunctions('versions', getVersion);
}
